import { EventType, PublicClientApplication } from "@azure/msal-browser";
import React, { useEffect, useState } from "react";
import { hasRoleFromClaims, msalConfig } from "./authConfig";
import { App } from "./App";

export const msalInstance = new PublicClientApplication(msalConfig as any);

export const AppAuth = () => {
  const [loginError, setLoginError] = useState("");

  useEffect(() => {
    let callbackId: string | null = null;

    const validateAndActivateAccount = async (account: any, roles: unknown) => {
      if (!account) {
        return;
      }

      if (!hasRoleFromClaims(roles ?? account?.idTokenClaims?.roles)) {
        setLoginError("The user does not have the required CCuser app role");
        await msalInstance.logoutRedirect({ account });
        return;
      }

      setLoginError("");
      msalInstance.setActiveAccount(account);
    };

    (async () => {
      await msalInstance.initialize();

      const redirectResponse = await msalInstance.handleRedirectPromise();
      const cachedAccount =
        redirectResponse?.account ??
        msalInstance.getActiveAccount() ??
        msalInstance.getAllAccounts()[0];

      await validateAndActivateAccount(
        cachedAccount,
        redirectResponse?.idTokenClaims
          ? (redirectResponse.idTokenClaims as any).roles
          : cachedAccount?.idTokenClaims?.roles
      );

      // event: any => some bad typings
      callbackId = msalInstance.addEventCallback(async (event: any) => {
        if (
          event.eventType === EventType.LOGIN_SUCCESS &&
          event.payload.account
        ) {
          const account = event.payload.account;

          await validateAndActivateAccount(
            account,
            event.payload?.idTokenClaims?.roles
          );
        }

        if (event.eventType === EventType.LOGIN_FAILURE) {
          setLoginError("Login failed. Please try again.");
          console.log(JSON.stringify(event));
        }
      });
    })();

    return () => {
      if (callbackId) {
        msalInstance.removeEventCallback(callbackId);
      }
    };
  }, []);

  if (msalInstance) {
    return <App instance={msalInstance} loginError={loginError} />;
  } else {
    return <div>Loading...</div>;
  }
};

export default AppAuth;
